import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AddServiceIndex from "../../../../components/SidetabPages/Catalog/Services/AddServiceIndex";

const AddService = () => {
  return (
    <>
      <AnnouncementBar />
      <AddServiceIndex />
    </>
  );
};
export default AddService;
